import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-order-by-dialog',
  templateUrl: './order-by-dialog.component.html'
})
export class OrderByDialogComponent implements OnInit {

  orderByList: any = []
  orderBy: any = {}
  orderByDirectionList: any = [
    { label: 'Crescente', value: 'asc' },
    { label: 'Decrescente', value: 'desc' }
  ]
  orderByDirection: any = {}
  confirmResult: Subject<any>

  constructor(public modalRef: BsModalRef) { }

  ngOnInit() {
    this.confirmResult = new Subject()
    this.orderBy = this.orderByList[0].value
    this.orderByDirection = this.orderByDirectionList[0].value
  }

  changeOrderBy() {
    this.confirmResult.next({ orderBy: this.orderBy, orderByDirection: this.orderByDirection })
    this.modalRef.hide()
  }
}
